import { useEffect, useState } from 'react';

import { Container } from 'react-bootstrap';

import styles from './Home.module.css';
import cipaaLogo from '../../assets/img/cipaa-logo.png';
import fesaudeLogo from '../../assets/img/fesaude-logo2.png';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      content: 'Para visualizar a apuração da eleição da CIPAA',
      key: 1
    },
    {
      content: 'Faça o login no SisGeD',
      key: 2
    },
    {
      content: 'Clique no Menu Eleição e no Submenu Apuração CIPAA',
      key: 3
    },
    {
      content: 'Obrigado a todos que participaram da eleição!',
      key: 4
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <Container className={styles.container} fluid>
      <div className={styles.header}>
        <img src={fesaudeLogo} alt="FeSaúde Logo" className={styles.logo_fesaude} />
        <img src={cipaaLogo} alt="CIPAA Logo" className={styles.logo_cipaa} />

        <h1 className={styles.title}>Comissão Interna de Prevenção de Acidentes e de Assédio</h1>
        <h2 className={styles.subtitle}>Apuração da Eleição CIPAA</h2>
      </div>

      <div className={styles.sliderContainer}>
        {slides.map((slide, index) => (
          <div
            key={slide.key}
            className={`${styles.slider} ${index === currentSlide ? styles.sliderActive : styles.sliderInactive}`}
          >
            <div className={styles.sliderItem}>
              <p dangerouslySetInnerHTML={{ __html: slide.content.replace(/\n/g, '<br/>') }} />
            </div>
          </div>
        ))}
      </div>

      <div className={styles.sliderNavigation}>
        {slides.map((_, index) => (
          <div
            key={index}
            className={`${styles.navDot} ${index === currentSlide ? styles.navDotActive : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </Container>
  );
};

export default Home;
